import { EstimateQuestionDownloadDto } from 'collaboration-service';
import * as React from 'react';
import EditPartContainer, { EditPartContainerType } from '../EditPartContainer';
import EditPartLabelAndEditor from '../EditPartLabelAndEditor';
import EditBoolean from '../Editors/EditBoolean';
import EditLanguageStrings from '../Editors/EditLanguageStrings';
import EditNumber from '../Editors/EditNumber';
import EditNumberWithSlider from '../Editors/EditNumberWithSlider';
import GenPropQuestion from './GenPropQuestion';
import PrePostFixQuestion from './PrePostFixQuestion';

interface PostEditQuizEstimateQuestionProps {
    epc: EditPartContainerType;
    registerClosed?: boolean;
}

const PostEditQuizEstimateQuestion = (p: PostEditQuizEstimateQuestionProps) => {
    const { epc, registerClosed } = p;

    return (
        <>
            <GenPropQuestion epc={epc} registerClosed={registerClosed} />
            <EditPartContainer icon="asking" title="basic settings" {...epc} registerClosed={registerClosed}>
                <EditPartLabelAndEditor>
                    {[
                        { label: { icon: "tag", content: "digits" }, editor: <EditNumberWithSlider<EstimateQuestionDownloadDto> getter={x => x.digits} min={0} max={10} /> },
                        { label: { icon: "stats", content: "min value" }, editor: <EditNumber<EstimateQuestionDownloadDto> getter={x => x.minValue} min={0} max={10000} step={1} /> },
                        { label: { icon: "stats", content: "max value" }, editor: <EditNumber<EstimateQuestionDownloadDto> getter={x => x.maxValue} min={0} max={10000} step={1} /> },
                        { label: { icon: "star full", content: "step" }, editor: <EditNumber<EstimateQuestionDownloadDto> getter={x => x.step} min={0} max={10000} step={1} /> },
                        { label: { icon: "shapes", content: "step" }, editor: <EditBoolean<EstimateQuestionDownloadDto> getter={x => x.showKiloDelimiter} /> },
                        { label: { icon: "cog", content: "correct value" }, editor: <EditNumber<EstimateQuestionDownloadDto> getter={x => x.correctValue} min={0} max={10000} step={1} /> },
                        { label: { icon: "add circle", content: "acceptable delta" }, editor: <EditNumber<EstimateQuestionDownloadDto> getter={x => x.acceptableDelta} min={0} max={10000} step={1} /> },
                        { label: { icon: "unpublish", content: "units" }, editor: <EditLanguageStrings<EstimateQuestionDownloadDto> getter={x => x.units} /> },
                    ]}
                </EditPartLabelAndEditor>
            </EditPartContainer>
            <PrePostFixQuestion epc={epc} registerClosed={registerClosed} />
        </>
    );
}
export default PostEditQuizEstimateQuestion;